export default __webpack_public_path__ + "static/media/recently_viewed.064fb61f.svg";